import React from 'react';
import { ButtonIcon } from './ButtonIcon';
import moment from 'moment';
import { DatePicker } from 'material-ui';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class InputDate extends React.Component {

    datePickerDialog;

    constructor(props) {
        super(props);
        this.state = {
            pickerOpened: false,
        };
    }

    render() {
        const {
            col,
            label,
            value,
            error,
            onBlur = () => null,
            touched = false,
            readOnly = false,
            disabled = false,
            submitFailed = false,
            className,
        } = this.props;

        const formDateInputClassName = classNames('form-date-input', className);

        return (
            <div className={col}>
                <div className={'form-group'}>
                    <label>{label}</label>
                    <div className={formDateInputClassName}>
                        <input
                            type="text"
                            value={value || ''}
                            disabled={disabled}
                            readOnly={readOnly}
                            className="form-control"
                            placeholder="DD/MM/AAAA"
                            onChange={this.handleChange}
                            onBlur={() => onBlur(undefined)}
                        />
                        <ButtonIcon
                            icon={'date_range'}
                            className="form-date-button"
                            onClick={this.handleOpenPicker}
                        />
                    </div>
                    <div className="input-border"/>
                    <label className="error">
                        {
                            submitFailed && touched ? error : ''
                        }
                    </label>
                    <DatePicker
                        ref={ref => this.datePickerDialog = ref}
                        className={'hide'}
                        DateTimeFormat={global.Intl.DateTimeFormat}
                        onChange={this.handleChangePicker}
                        disabled={disabled}
                        locale={'es-ES'}
                    />
                </div>
            </div>
        );
    }

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // - - DATE INPUT

    handleChange = (event) => {
        this.props.onChange(event.target.value);
    };

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // - - DATE PICKER

    handleOpenPicker = (event) => {
        event.preventDefault();
        this.datePickerDialog.refs.dialogWindow.show();
    };

    handleChangePicker = (_, value) => {
        const date = moment(value).format('DDMMYYYY');
        this.props.onChange(date);
    };

    // Si se quiere asignar un valor inicial al picker es necesario actualizar la versión de materials

}

InputDate.propTypes = {
    className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/InputDate.jsx